module.exports = __webpack_public_path__ + "static/img/paiduitongzhi2.cc2d3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/paiduitongzhi2.png
// module id = zcWe
// module chunks = 24